<template>
  <div>
    <div class="float-lg-right mb-3">
      <!-- <download-excel :fetch="fetchData" class="btn btn-outline-success default" :fields="json_fields" name="orderList.xls" :meta="json_meta" :stringifyLongNum="true">Excel
      </download-excel> -->
      <button type="button" class="btn btn-outline-success default" @click="getExcelData">
        Excel
      </button>
      <button class="barcode btn" @click="barcodeClick"> {{ barcodeText }}</button>
    </div>
    <b-table-simple head-variant="light" class="vuetable" responsive>
      <b-thead head-variant="light">
        <b-tr v-if="!useDate">
          <template v-for="(field , idx) in useDateFields">
            <b-th style="text-align: center" :key="idx" :rowspan="idx <= 3 ? '2' : 0" v-if="idx <=3">{{
                field.label
              }}
            </b-th>
            <b-th style="text-align: center" :key="idx" :colspan="idx === 5 ? '6' : '0'"
                  v-if="idx === 5 && !String(fullPath).includes('sales-status')">{{ field.label }}
            </b-th>
            <b-th style="text-align: center" :key="idx" :colspan="idx === 6 ? '6' : '0'"
                  v-if="idx === 6 && String(fullPath).includes('sales-status')">{{ field.label }}
            </b-th>
            <b-th style="text-align: center" :key="idx" :colspan="idx === 6 ? '3' : '0'"
                  v-if="idx === 6 && !String(fullPath).includes('sales-status')">{{
                field.label
              }}
            </b-th>
            <b-th style="text-align: center" :key="idx" :colspan="idx === 7 ? '3' : '0'"
                  v-if="idx === 7 && String(fullPath).includes('sales-status')">{{
                field.label
              }}
            </b-th>
            <b-th style="text-align: center" :key="idx" :rowspan="idx === 7 ? '2' : '0'"
                  v-if="idx === 7 && !String(fullPath).includes('sales-status')">{{
                field.label
              }}
            </b-th>
            <b-th style="text-align: center" :key="idx" :rowspan="idx === 8 ? '2' : '0'" v-if="idx === 8">{{
                field.label
              }}
            </b-th>
            <b-th style="text-align: center" :key="idx" :rowspan="idx === 9 ? '2' : '0'" v-if="idx ===9">{{
                field.label
              }}
            </b-th>
          </template>
        </b-tr>
        <b-tr v-else>
          <template v-for="(field , idx) in useDateFields">
            <b-th style="text-align: center" :key="idx" :rowspan="idx <= 4 ? '2' : 0" v-if="idx <= 4">{{
                field.label
              }}
            </b-th>
            <b-th style="text-align: center" :key="idx" :colspan="idx === 6 ? '5' : '0'" v-if="idx === 6">{{
                field.label
              }}
            </b-th>
            <b-th style="text-align: center" :key="idx" :colspan="idx === 7 ? '3' : '0'" v-if="idx === 7">{{
                field.label
              }}
            </b-th>
            <b-th style="text-align: center" :key="idx" :rowspan="idx === 8 ? '2' : '0'" v-if="idx === 8">{{
                field.label
              }}
            </b-th>
            <b-th style="text-align: center" :key="idx" :rowspan="idx === 9 ? '2' : '0'" v-if="idx === 9">{{
                field.label
              }}
            </b-th>
          </template>
        </b-tr>
        <b-tr>
          <template v-for="(field , idx) in useDateFields">
            <b-th style="text-align: center" :key="idx" v-if="idx === 4 && !useDate && !String(fullPath).includes('sales-status')">{{ field.label }}</b-th>
            <b-th style="text-align: center" :key="idx" v-if="idx > 8 && !useDate && !String(fullPath).includes('sales-status')">{{ field.label }}</b-th>
            <b-th style="text-align: center" :key="idx" v-if="idx === 5 && useDate && !String(fullPath).includes('sales-status')">{{ field.label }}</b-th>
            <b-th style="text-align: center" :key="idx" v-if="idx > 9 && useDate && !String(fullPath).includes('sales-status')">{{ field.label }}</b-th>

            <b-th style="text-align: center" :key="idx" v-if="idx === 4 && !useDate && String(fullPath).includes('sales-status')">{{ field.label }}</b-th>
            <b-th style="text-align: center" :key="idx" v-if="idx === 5 && !useDate && String(fullPath).includes('sales-status')">{{ field.label }}</b-th>
            <b-th style="text-align: center" :key="idx" v-if="idx > 9 && !useDate && String(fullPath).includes('sales-status')">{{ field.label }}</b-th>
            <b-th style="text-align: center" :key="idx" v-if="idx === 6 && useDate && String(fullPath).includes('sales-status')">{{ field.label }}</b-th>
            <b-th style="text-align: center" :key="idx" v-if="idx > 10 && useDate && String(fullPath).includes('sales-status')">{{ field.label }}</b-th>
          </template>
        </b-tr>
      </b-thead>
      <b-tbody>
        <template v-for="(item , i ) in orderList">
          <b-tr :key="i">
            <b-td v-if="useDate">{{ item.useDate.substr(0, 10) }}</b-td>
            <b-td style="text-align:center">
              <span>{{ item.itemNo }}</span>
              <barcode font-size="0" v-bind:value="item.itemNo" v-if="barcodeIsR">
                Show this if the rendering fails.
              </barcode>
            </b-td>
            <b-td style="text-align:center">{{ goodsTypeVal(item.goodsType) }}</b-td>
            <b-td style="text-align:center">{{ item.goodsName }}</b-td>
            <b-td style="text-align:center">{{ item.optionName }}</b-td>
            <b-td style="text-align:center" v-if="String(fullPath).includes('sales-status')">{{ item.listPrice | currency }}</b-td>
            <b-td style="text-align:center">{{ item.originalSalePrice | currency }}</b-td>
            <b-td style="text-align:center">{{ item.salePrice | currency }}</b-td>
            <b-td style="text-align:center">{{ item.salesDeliveryPrice | currency }}</b-td>
            <b-td style="text-align:center">{{ item.discountAmount | currency }}</b-td>
            <b-td style="text-align:center">{{ item.salesCommission | currency }}</b-td>
            <b-td style="text-align:center">{{ item.penalty | currency }}</b-td>
            <b-td style="text-align:center">{{ item.penaltyDeliveryPrice | currency }}</b-td>
            <b-td style="text-align:center">{{ item.penaltyCommission | currency }}</b-td>
            <b-td style="text-align:center">{{ item.buyerName }}</b-td>
            <b-td style="text-align:center"  v-if="item.selfSales == false">
              <div>

              </div>
            </b-td>
            <b-td style="text-align:center"  v-if="item.selfSales == true">
              <div>
                Y
              </div>
            </b-td>
          </b-tr>
        </template>
        <template v-if="!useDate">
          <b-tr>
            <b-th style="text-align:center;background:#f6c797 !important">합계 :</b-th>
            <b-th style="text-align:center;background:#f6c797 !important" colspan="3"></b-th>
            <b-th style="text-align:center;background:#f6c797 !important"
                  v-if="!String(fullPath).includes('sales-status')"></b-th>
            <b-th style="text-align:center;background:#f6c797 !important; color: red;" class="text-center align-middle">
              {{ totalData('listPrice') }}
            </b-th>
            <b-th style="text-align:center;background:#f6c797 !important; color: red;" class="text-center align-middle">
              {{ totalData('originalSalePrice') }}
            </b-th>
            <b-th style="text-align:center;background:#f6c797 !important; color: red;" class="text-center align-middle">
              {{ totalData('salePrice') }}
            </b-th>
            <b-th style="text-align:center;background:#f6c797 !important; color: red;" class="text-center align-middle">
              {{ totalData('salesDeliveryPrice') }}
            </b-th>
            <b-th style="text-align:center;background:#f6c797 !important; color: red;" class="text-center align-middle">
              {{ totalData('discountAmount') }}
            </b-th>
            <b-th style="text-align:center;background:#f6c797 !important; color: red;" class="text-center align-middle">
              {{ totalData('salesCommission') }}
            </b-th>
            <b-th style="text-align:center;background:#f6c797 !important; color: red;" class="text-center align-middle">
              {{ totalData('penalty') }}
            </b-th>
            <b-th style="text-align:center;background:#f6c797 !important; color: red;" class="text-center align-middle">
              {{ totalData('penaltyDeliveryPrice') }}
            </b-th>
            <b-th style="text-align:center;background:#f6c797 !important; color: red;" class="text-center align-middle">
              {{ totalData('penaltyCommission') }}
            </b-th>
            <b-th style="text-align:center;background:#f6c797 !important; color: red;"></b-th>
            <b-th style="text-align:center;background:#f6c797 !important; color: red;"></b-th>
          </b-tr>
        </template>
<!--정산현황 세부내 사용일별-->
        <template v-if="useDate">
          <b-tr>
            <b-th style="text-align:center;background:#f6c797 !important">합계 :</b-th>
            <b-th style="text-align:center;background:#f6c797 !important" colspan="3"></b-th>
            <b-th style="text-align:center;background:#f6c797 !important"
                  v-if="!String(fullPath).includes('sales-status')"></b-th>
            <b-th style="text-align:center;background:#f6c797 !important; color: red;" class="text-center align-middle">
              {{ totalData('originalSalePrice') }}
            </b-th>
            <b-th style="text-align:center;background:#f6c797 !important; color: red;" class="text-center align-middle">
              {{ totalData('salePrice') }}
            </b-th>
            <b-th style="text-align:center;background:#f6c797 !important; color: red;" class="text-center align-middle">
              {{ totalData('salesDeliveryPrice') }}
            </b-th>
            <b-th style="text-align:center;background:#f6c797 !important; color: red;" class="text-center align-middle">
              {{ totalData('discountAmount') }}
            </b-th>
            <b-th style="text-align:center;background:#f6c797 !important; color: red;" class="text-center align-middle">
              {{ totalData('salesCommission') }}
            </b-th>
            <b-th style="text-align:center;background:#f6c797 !important; color: red;" class="text-center align-middle">
              {{ totalData('penalty') }}
            </b-th>
            <b-th style="text-align:center;background:#f6c797 !important; color: red;" class="text-center align-middle">
              {{ totalData('penaltyDeliveryPrice') }}
            </b-th>
            <b-th style="text-align:center;background:#f6c797 !important; color: red;" class="text-center align-middle">
              {{ totalData('penaltyCommission') }}
            </b-th>
            <b-th style="text-align:center;background:#f6c797 !important; color: red;"></b-th>
            <b-th style="text-align:center;background:#f6c797 !important; color: red;"></b-th>
          </b-tr>
        </template>
      </b-tbody>

    </b-table-simple>

    <!--    <b-pagination size="sm"-->
    <!--                  align="center"-->
    <!--                  :total-rows="total"-->
    <!--                  :per-page="perPage"-->
    <!--                  v-model="currentPage"-->
    <!--    >-->
    <!--      <template v-slot:next-text>-->
    <!--        <i class="simple-icon-arrow-right"/>-->
    <!--      </template>-->
    <!--      <template v-slot:prev-text>-->
    <!--        <i class="simple-icon-arrow-left"/>-->
    <!--      </template>-->
    <!--      <template v-slot:first-text>-->
    <!--        <i class="simple-icon-control-start"/>-->
    <!--      </template>-->
    <!--      <template v-slot:last-text>-->
    <!--        <i class="simple-icon-control-end"/>-->
    <!--      </template>-->
    <!--    </b-pagination>-->

  </div>
</template>

<script>
import {
  mapGetters,
} from "vuex";
import {
  alignTableCenter,
  currencyFilter,
  getGoodsTypeStr
} from "../../../utils";
import VueBarcode from 'vue-barcode';
import XLSX from "xlsx"
import {order} from '../../../constants/api';

export default {
  components: {
    'barcode': VueBarcode
  },
  props: ['useDate', 'data', 'fullPath'],
  filters: {
    ...currencyFilter
  },
  data() {
    return {
      barcodeText: "바코드 보기",
      barcodeIsR: false,
      currentPage: 1,
      perPage: 30,
      total: 0,
      searchDate: null,
      goodsType: null,
      orderList: [],
      barcodeValue: '',
      fields: [{
        key: "couponSerial",
        label: "쿠폰번호",
        ...alignTableCenter
      },
        {
          key: "goodsType",
          label: "상품구분",
          ...alignTableCenter
        },
        {
          key: "goodsName",
          label: "상품명",
          ...alignTableCenter
        },
        {
          key: "optionName",
          label: "옵션명",
          ...alignTableCenter
        },
        {
          key: "listPrice",
          label: "정상가",
          ...alignTableCenter
        },
        {
          key: "salePrice",
          label: "판매가",
          ...alignTableCenter
        },
        {
          key: "salesFormUse",
          label: "사용매출",
          ...alignTableCenter
        },
        {
          key: "cancelFeeSales",
          label: "위약금 매출",
          ...alignTableCenter
        },
        {
          key: "Buyer",
          label: "구매자/예약자",
          ...alignTableCenter
        },
        {
          key: "selfSales",
          label: "자체판매",
          ...alignTableCenter
        },

        {
          key: "salesAmountTotal",
          label: "실판매가",
          ...alignTableCenter
        },
        {
          key: "salesDeliveryAmountTotal",
          label: "입금액",
          ...alignTableCenter
        },
        {
          key: "discountAmountTotal",
          label: "시간대 할인금액",
          ...alignTableCenter
        },
        {
          key: "salesCommissionTotal",
          label: "수수료",
          ...alignTableCenter
        },
        {
          key: "salesCommissionTotal",
          label: "위약금",
          ...alignTableCenter
        },
        {
          key: "salesCommissionTotal",
          label: "위약금 입금액",
          ...alignTableCenter
        },
        {
          key: "salesCommissionTotal",
          label: "위약금 수수료",
          ...alignTableCenter
        },
      ],
      json_fields: {
        '사용일': 'useDate',
        '쿠폰번호': 'couponSerial',
        '상품구분': 'goodsType',
        '상품명': 'goodsName',
        '옵션명': 'optionName',
        '판매가': 'originalSalePrice',
        '시간대 할인금액': 'discountAmount',
        '실판매가': 'salePrice',
        '입금액': 'salesDeliveryPrice',
        '수수료': 'salesCommission',
        '위약금': 'penalty',
        '위약금 입금액': 'penaltyDeliveryPrice',
        '위약금 수수료': 'penaltyCommission',
        '구매자/예약자': 'Buyer',
        '자체판매': 'selfSales'
      },
      json_meta: [
        [{
          'key': 'charset',
          'value': 'utf-8'
        }]
      ],
      excelData: []
    }
  },
  computed: {
    ...mapGetters([]),
    useDateFields: {
      get: function () {
        return this.useDate ? [{
          key: 'useDate',
          label: '사용일',
          ...alignTableCenter
        }, ...this.fields] : this.fields
      }
    }
  },
  mounted() {
    // console.log(this.fullPath)
    if (!String(this.fullPath).includes('sales-status')) {
      this.fields.splice(4, 1)
    }
  },
  methods: {
    getExcelData() {
      this.fetchData();
      let data =  {
        A: "사용일",
        B: "쿠폰번호",
        C: "상품구분",
        D: "상품명",
        E: "옵션명",
        P: "정상가",
        F: "판매가",
        G: "시간대 할인금액",
        H: '실판매가',
        I: "입금액",
        J: "수수료",
        K: "위약금",
        L: "위약금 입금액",
        M: "위약금 수수료",
        N: "구매자/예약자",
        O: "자체판매",
      };
      if(!String(this.fullPath).includes('sales-status')){
        delete data.P;
      }


      let excelheader = XLSX.utils.json_to_sheet(
        [
          data,
        ],
        {skipHeader: true}
      );
      console.log(this.excelData)
      XLSX.utils.sheet_add_json(excelheader, this.excelData.map(this.dataconvert), {
        skipHeader: true,
        origin: "A2",
      });
      let wb = XLSX.utils.book_new(); // make Workbook of Excel

      XLSX.utils.book_append_sheet(wb, excelheader, "orderList");
      // export Excel file
      XLSX.writeFile(wb, "orderList.xlsx");
    },
    dataconvert(oreder, idx) {
      let data =  {
        A: oreder.useDate,//사용일
        B: oreder.couponSerial, //쿠폰번호
        C: oreder.goodsType,// 상품구분
        D: oreder.goodsName,//상품명
        E: oreder.optionName,//옵션명
        P: Number(oreder.listPrice),//정상가
        F: Number(oreder.originalSalePrice),//판매가
        G: Number(oreder.discountAmount),//시간대 할인금액
        H: Number(oreder.salePrice),//실판매가
        I: Number(oreder.salesDeliveryPrice),//입금액
        J: Number(oreder.salesCommission),//수수료
        K: Number(oreder.penalty),//위약금
        L: Number(oreder.penaltyDeliveryPrice),//위약금 입금액
        M: Number(oreder.penaltyCommission),// 위약금 수수료
        N: oreder.Buyer,
        O: oreder.selfSales,
      };
      if(!String(this.fullPath).includes('sales-status')){
        delete data.P;
      }
      return data;
    },
    goodsTypeVal(val) {
      return getGoodsTypeStr(val);
    },
    totalData(data) {
      let originalSalePrice = 0,
        salePrice = 0,
        listPrice=0,
        salesDeliveryPrice = 0,
        discountAmount = 0,
        salesCommission = 0,
        penalty = 0,
        penaltyDeliveryPrice = 0,
        penaltyCommission = 0;
      this.orderList.forEach((el) => {
        originalSalePrice += Number(el.originalSalePrice);
        salePrice += Number(el.salePrice);
        listPrice += Number(el.listPrice);
        salesDeliveryPrice += Number(el.salesDeliveryPrice);
        discountAmount += Number(el.discountAmount);
        salesCommission += Number(el.salesCommission);
        penalty += Number(el.penalty);
        penaltyDeliveryPrice += Number(el.penaltyDeliveryPrice);
        penaltyCommission += Number(el.penaltyCommission);
      });
      if (data == "count") {
        return count;
      }  else if (data == "listPrice") {
        return listPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }  else if (data == "originalSalePrice") {
        return originalSalePrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else if (data == "salePrice") {
        return salePrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else if (data == "salesDeliveryPrice") {
        return salesDeliveryPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else if (data == "discountAmount") {
        return discountAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else if (data == "salesCommission") {
        return salesCommission.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else if (data == "penalty") {
        return penalty.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else if (data == "penaltyDeliveryPrice") {
        return penaltyDeliveryPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else if (data == "penaltyCommission") {
        return penaltyCommission.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    barcodeClick() {
      if (this.barcodeIsR == false) {
        this.barcodeIsR = true;
        this.barcodeText = "바코드 숨김";
      } else {
        this.barcodeIsR = false;
        this.barcodeText = "바코드 보기";
      }
    },
    init(date, goodsType, item) {
      this.searchDate = date
      this.goodsType = goodsType
      this.item = item
      this.loadData()
    },

    loadData() {

      /**
       * 1. 특정날짜, 특정상품유형
       * 2. 모든날짜, 특정상품유형(하단합계)
       * 3. 특정날짜, 모든상품유형
       * 4. 모든날짜, 모든상품유형(우측합계)
       */

      const vm = this
      this.orderList = []

      if (this.searchDate == null) { //모든날짜

        this.item.forEach(function (v, index) {

          //goodsType : Booking, BookingCoupon, MobileCoupon, Summary(정산현황), null(매출현황)
          if (vm.goodsType == null) {
            v.orders.forEach(function (vv, index) {
              vv.orderItems.forEach(function (vvv, index) {
                vm.orderList.push(vvv)
              })
            })
          }

          if (v.BookingCoupon != null && (vm.goodsType == "BookingCoupon" || vm.goodsType == "Summary")) {
            v.BookingCoupon.orders.forEach(function (vv, index) {
              vv.orderItems.forEach(function (vvv, index) {
                vm.orderList.push(vvv)
              })
            })
          }

          if (v.MobileCoupon != null && (vm.goodsType == "MobileCoupon" || vm.goodsType == "Summary")) {
            v.MobileCoupon.orders.forEach(function (vv, index) {
              vv.orderItems.forEach(function (vvv, index) {
                vm.orderList.push(vvv)
              })
            })
          }

          if (v.StoreBooking != null && (vm.goodsType == "StoreBooking" || vm.goodsType == "Summary")) {
            v.StoreBooking.orders.forEach(function (vv, index) {
              vv.orderItems.forEach(function (vvv, index) {
                vm.orderList.push(vvv)
              })
            })
          }

          if (v.MoneyCoupon != null && (vm.goodsType == "MoneyCoupon" || vm.goodsType == "Summary")) {
            v.MoneyCoupon.orders.forEach(function (vv, index) {
              vv.orderItems.forEach(function (vvv, index) {
                vm.orderList.push(vvv)
              })
            })
          }

        })

      } else {

        if (this.item.MoneyCoupon != null && (this.goodsType == "MoneyCoupon" || this.goodsType == "Summary")) {
          this.item.MoneyCoupon.orders.forEach(function (v, index) {
            v.orderItems.forEach(function (vv, index) {
              vm.orderList.push(vv)
            })
          })
        }

        if (this.item.BookingCoupon != null && (this.goodsType == "BookingCoupon" || this.goodsType == "Summary")) {
          this.item.BookingCoupon.orders.forEach(function (v, index) {
            v.orderItems.forEach(function (vv, index) {
              vm.orderList.push(vv)
            })
          })
        }

        if (this.item.MobileCoupon != null && (this.goodsType == "MobileCoupon" || this.goodsType == "Summary")) {
          this.item.MobileCoupon.orders.forEach(function (v, index) {
            v.orderItems.forEach(function (vv, index) {
              vm.orderList.push(vv)
            })
          })
        }

        if (this.item.StoreBooking != null && (this.goodsType == "StoreBooking" || this.goodsType == "Summary")) {
          this.item.StoreBooking.orders.forEach(function (v, index) {
            v.orderItems.forEach(function (vv, index) {
              vm.orderList.push(vv)
            })
          })
        }

      }
    },

    loadData2() {

    },

    fetchData() {
      this.excelData = [];
      this.orderList.forEach((v) => {
        let selfs;
        if (v.selfSales == true) {
          selfs = 'Y';
        } else {
          selfs = '';
        }

        let newStr = v.itemNo
        this.excelData.push({
          'useDate': v.useDate.substr(0, 10),
          'goodsType': this.goodsTypeVal(v.goodsType),
          'couponSerial': newStr.trim(),
          'goodsName': v.goodsName,
          'optionName': v.optionName,
          'originalSalePrice': Number(v.originalSalePrice),
          'discountAmount': Number(v.discountAmount),
          'listPrice': Number(v.listPrice),
          'salePrice': Number(v.salePrice),
          'salesDeliveryPrice': Number(v.salesDeliveryPrice),
          'salesCommission': Number(v.salesCommission),
          'penalty': Number(v.penalty),
          'penaltyDeliveryPrice': Number(v.penaltyDeliveryPrice),
          'penaltyCommission': Number(v.penaltyCommission),
          'Buyer': v.buyerName,
          'selfSales': selfs,
        })
        console.log(this.orderList)
      })
    }
  },
  watch: {}
}
</script>

<style scoped>
.barcode {
  background: none;
  border: 1px solid #c11314;
  color: #c11314;
  border-radius: 0;
  margin-left: 5px;
}

.table .thead-light th {
  border: 1px solid #fff !important;
  vertical-align: middle;
}
</style>
